import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import toast from 'react-hot-toast';

const DAYS = [
  {key:'monday', label:'Lundi'},
  {key:'tuesday', label:'Mardi'},
  {key:'wednesday', label:'Mercredi'},
  {key:'thursday', label:'Jeudi'},
  {key:'friday', label:'Vendredi'},
  {key:'saturday', label:'Samedi'},
  {key:'sunday', label:'Dimanche'},
];

export default function DoctorAvailability() {
  const [schedule, setSchedule] = useState(
    DAYS.reduce((acc, d) => ({...acc, [d.key]: {active:false, start:'08:00', end:'17:00'}}), {})
  );
  const [duration, setDuration] = useState(30);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/auth/me').then(res => {
      const doc = res.data.doctor;
      if (doc) {
        setDuration(doc.appointment_duration || 30);
        if (doc.availabilities?.length > 0) {
          const newSchedule = {...schedule};
          doc.availabilities.forEach(a => {
            newSchedule[a.day_of_week] = {
              active: true,
              start: a.start_time.substring(0,5),
              end: a.end_time.substring(0,5),
            };
          });
          setSchedule(newSchedule);
        }
      }
    });
  }, []);

  const toggle = (day) => {
    setSchedule(s => ({...s, [day]: {...s[day], active: !s[day].active}}));
  };

  const save = async () => {
    setLoading(true);
    const availabilities = Object.entries(schedule)
      .filter(([_, v]) => v.active)
      .map(([day, v]) => ({day_of_week: day, start_time: v.start, end_time: v.end}));

    try {
      await api.post('/doctor/availabilities', { availabilities });
      await api.put('/doctor/profile', { appointment_duration: duration });
      toast.success('Disponibilités enregistrées !');
    } catch(e) {
      toast.error(e.response?.data?.message || 'Erreur');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/doctor/dashboard" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Mes disponibilités</h1>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        {/* Durée consultation */}
        <div className="card">
          <h3 className="font-bold text-gray-800 mb-3">⏱ Durée par consultation</h3>
          <div className="flex gap-2">
            {[15, 20, 30, 45, 60].map(d => (
              <button key={d} onClick={() => setDuration(d)}
                className={`flex-1 py-2 rounded-xl text-sm font-medium border-2 transition-all ${duration===d ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-200 text-gray-600'}`}>
                {d}min
              </button>
            ))}
          </div>
        </div>

        {/* Jours */}
        <div className="card space-y-3">
          <h3 className="font-bold text-gray-800">📅 Jours et horaires</h3>
          {DAYS.map(({ key, label }) => (
            <div key={key} className={`p-3 rounded-xl border-2 transition-all ${schedule[key].active ? 'border-green-300 bg-green-50' : 'border-gray-100 bg-gray-50'}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-gray-700">{label}</span>
                <button onClick={() => toggle(key)}
                  className={`w-12 h-6 rounded-full transition-all ${schedule[key].active ? 'bg-green-500' : 'bg-gray-300'}`}>
                  <div className={`w-5 h-5 bg-white rounded-full shadow transition-all mx-0.5 ${schedule[key].active ? 'translate-x-6' : 'translate-x-0'}`} />
                </button>
              </div>
              {schedule[key].active && (
                <div className="flex items-center gap-2">
                  <input type="time" value={schedule[key].start}
                    onChange={e => setSchedule(s => ({...s, [key]: {...s[key], start: e.target.value}}))}
                    className="input-field text-sm py-1.5 flex-1" />
                  <span className="text-gray-400 text-sm">→</span>
                  <input type="time" value={schedule[key].end}
                    onChange={e => setSchedule(s => ({...s, [key]: {...s[key], end: e.target.value}}))}
                    className="input-field text-sm py-1.5 flex-1" />
                </div>
              )}
            </div>
          ))}
        </div>

        <button onClick={save} disabled={loading} className="btn-primary w-full py-3">
          {loading ? 'Enregistrement...' : '💾 Sauvegarder les disponibilités'}
        </button>
      </div>
    </div>
  );
}
